/*
  Better Together — source PDP section behaviour (Step 4).
  ==========================================================================
  1. Mirrors the buy box's selected size into the "THIS ITEM" card, across
     both buy boxes this theme uses:
       - product-form-alternate  → input[data-bb-size-radio] (+ bb:section-reloaded)
       - Prestige product-form    → variant:changed on the form (bubbles)
  2. Opens the quick view (Step 5) on companion-card / CTA tap by dispatching a
     cancelable 'bt:open-quickview' event; if nothing handles it yet, falls back
     to the companion PDP with ?pair params.
  Document-level + delegated so it survives section re-renders. Deferred.
  ==========================================================================
*/
(function () {
  if (window.__betterTogether) return;
  window.__betterTogether = true;

  function shortSize(v) {
    return String(v || '').split(' ')[0].split('.')[0].trim();
  }

  function setThisSize(root, code) {
    var el = root.querySelector('[data-bt-this-size]');
    if (el) el.textContent = code ? ('Size: ' + code + ' · from buy box') : 'Size: — · from buy box';
  }

  function currentBuyBoxSize() {
    var checked = document.querySelector('input[data-bb-size-radio]:checked');
    if (checked) return shortSize(checked.value);
    return null;
  }

  function syncAll() {
    var code = currentBuyBoxSize();
    document.querySelectorAll('[data-bt-root]').forEach(function (r) { setThisSize(r, code); });
  }

  /* product-form-alternate: size radios */
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('input[data-bb-size-radio]')) {
      var code = shortSize(e.target.value);
      document.querySelectorAll('[data-bt-root]').forEach(function (r) { setThisSize(r, code); });
    }
  });

  /* Prestige product-form: variant:changed bubbles to document */
  document.addEventListener('variant:changed', function (e) {
    var v = e.detail && e.detail.variant;
    if (!v) return;
    // pick the size-ish option
    var code = null;
    (v.options || []).forEach(function (o) { if (/\d|xs|^s$|^m$|^l$|xl/i.test(o)) code = shortSize(o); });
    if (!code && v.title) code = shortSize(v.title);
    document.querySelectorAll('[data-bt-root]').forEach(function (r) { setThisSize(r, code); });
  });

  document.addEventListener('bb:section-reloaded', syncAll);

  /* open quick view (or fall back to navigation) */
  document.addEventListener('click', function (e) {
    var trig = e.target.closest && e.target.closest('[data-bt-open]');
    if (!trig) return;
    var root = trig.closest('[data-bt-root]');
    if (!root) return;
    var detail = {
      companion: root.getAttribute('data-bt-companion-handle'),
      pct: parseInt(root.getAttribute('data-bt-pct'), 10) || 0,
      source: root.getAttribute('data-bt-source-handle'),
      trigger: trig
    };
    var ev = new CustomEvent('bt:open-quickview', { bubbles: true, cancelable: true, detail: detail });
    document.dispatchEvent(ev);
    // If a quick-view handler took it (preventDefault), stop. Otherwise navigate.
    if (ev.defaultPrevented) { e.preventDefault(); return; }
    if (trig.tagName !== 'A') {
      e.preventDefault();
      window.location.href = '/products/' + detail.companion + '?pair=' + detail.source;
    }
    // for an <a>, let the default href (companion?pair=) proceed
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAll); else syncAll();
})();
